<template>
  <div class="identity-container">
    <PageHeader :isShowBackIcon="false" :title="$t('身份认证')"></PageHeader>
    <div class="identity content_auto">
      <AuthCard
        v-for="(item, index) in authConfig"
        :key="index"
        :idx="index"
        :config="item"
        :status="userInfo[['c1Status', 'c2Status', 'c3Status'][index]]"
        :userKYCLevel="userKYCLevel"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { KYCAuth } from './KYCAuth'
import { updateUserInfo } from '@/utils'
import AuthCard from './components/AuthCard'

export default {
  name: 'Identity',
  components: {
    AuthCard
  },
  data() {
    return {
      // isShowBackIcon: false,
      authConfig: [
        {
          title: `${this.$t('初级认证')}(KYC1)`,
          tips: [
            this.$t('1、可进行币币交易，只能买入币种，不能卖出币种。'),
            this.$t('2、能充币，但不能提币。')
          ],
          images: [
            require('@/assets/images/kyc1-bg.png'),
            require('@/assets/images/kyc1-1.png')
          ]
        },
        {
          title: `${this.$t('中级认证')}(KYC2)`,
          tips: [
            this.$t('1、可进行币币交易，买卖交易。'),
            this.$t('2、可进行充提币。')
          ],
          images: [
            require('@/assets/images/kyc2-bg.png'),
            require('@/assets/images/kyc2-1.png')
          ]
        },
        {
          title: `${this.$t('高级认证')}(KYC3)`,
          tips: [
            this.$t('1、可进行币币交易，买卖交易。'),
            this.$t('2、可进行充提币。'),
            this.$t('3、可享受法币商户特权。')
          ],
          images: [
            require('@/assets/images/kyc3-bg.png'),
            require('@/assets/images/kyc3-1.png')
          ]
        }
      ]
    }
  },
  async mounted() {
    await updateUserInfo()
  },
  computed: {
    ...mapState(['userInfo']),
    userKYCLevel() {
      const { c1Status, c2Status, c3Status } = this.userInfo
      /* eslint-disable */
      return c3Status === 'Yes'
        ? 3
        : c2Status === 'Yes'
        ? 2
        : c1Status === 'Yes'
        ? 1
        : 0
      /* eslint-enable */
    }
  }
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.isShowBackIcon = from.name === 'notcertified'
  //   })
  // }
}
</script>

<style lang="less" scoped>
/* ￥自定义混入函数 - 开始 */

.identity-container {
  .identity {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
